import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class PermissionService {
  getAllPermissions() {
    const options = {
      method: 'GET',
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(`${apiURL}/permissions`, options);
  }
}

export default PermissionService;
